function registerHandleBarsHelpers () {
  Handlebars.registerHelper('addressHelper', function (hotelInfo) {
    let address = [
      hotelInfo.addr1,
      hotelInfo.city,
      hotelInfo.zip,
      hotelInfo.country
    ]
    address = address.filter(function (value) {
      return value
    }).join(', ')
    return address
  })

  Handlebars.registerHelper('t', function () {
    let args = Array.prototype.slice.call(arguments)
    args = args.slice(0, -1) // Remove helper object
    const translationString = args.shift()
    // Expects to receive keyName then value (one or more times)
    const params = {}
    for (let i = 0; i < args.length; i += 2) {
      params[args[i]] = args[i + 1]
    }
    return i18next.t(translationString, params)
  })

  Handlebars.registerHelper('extrasHelper', function (extras) {
    const extrasText = []
    for (let i = 0; i < extras.length; i++) {
      extrasText.push(extras[i].text)
    }
    return extrasText.join(', ')
  })

  Handlebars.registerHelper('eqHelper', function (param1, param2) {
    return param1 === param2
  })

  Handlebars.registerHelper('telephoneHelper', function (language, number) {
    const telephoneNumber = '<span dir="ltr"><a href="tel:' + number + '" target="_blank" style="text-decoration:none; color:#FFFFFF;">' + number + '</a></span>'
    const label = i18next.t('email_tel_label')
    return label + ': ' + telephoneNumber
  })

  Handlebars.registerHelper('stripHtml', function (text) {
    if (!text) return ''
    return String(text).replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]*>/g, '').trim()
  })

  Handlebars.registerHelper('parasToLineBreaks', function (html) {
    if (!html) return ''
    return new Handlebars.SafeString(
      html
        .replace(/<\/p>/gi, '<br>')
        .replace(/<p[^>]*>/gi, '')
        .replace(/(<br\s*\/?>\s*)+$/i, '')
        .trim()
    )
  })
}

let lng = config.defaultLanguage
let cookieLng = getCookie('i18next')
if (cookieLng !== null) {
  // Remove t= so we just get the language code
  cookieLng = cookieLng.replace('t=', '')
  if (config.supportedLanguages.indexOf(cookieLng) !== -1) {
    lng = cookieLng
  }
}

i18next.use(i18nextHttpBackend).init({
  lng,
  load: 'currentOnly',
  fallbackLng: 'en',
  interpolation: {
    prefix: '__',
    suffix: '__',
    escapeValue: false
  },
  backend: {
    loadPath: '/locales/__lng__/__ns__.json'
  }
}).then(function () {
  registerHandleBarsHelpers()

  $(document).ready(function () {
    if ($('.page-login').length) {
      loginInit()
    }

    if ($('.page-greeter').length) {
      greeterInit()
    }

    if ($('.page-builder').length) {
      builderInit()
    }

    if ($('.page-emailer').length) {
      emailerInit()
    }
  })
})
